import { NoteType } from 'src/api/api.generated'
import { faHandSparkles, faPlaneArrival, faPlaneDeparture, faTowerCell, faUtensils, faNoteSticky } from '@fortawesome/pro-light-svg-icons'

export const noteIcon = (type: NoteType) => {
  switch (type) {
    case 'RESERVATION':
      return faNoteSticky
    case 'CHECKIN':
      return faPlaneArrival
    case 'CHECKOUT':
      return faPlaneDeparture
    case 'RESTAURANT':
      return faUtensils
    case 'HOUSEKEEPING':
      return faHandSparkles
    case 'PORTAL':
      return faTowerCell
    default:
      return faNoteSticky
  }
}